import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  const logoUrl = '/images/LOGOEXPEDIENTES.png';
  const santiagoPhotoUrl = '/images/santiago-traje.jpg';
  const angelicaPhotoUrl = 'https://files.tnonetwork.com/users/profile/angelicalugo2.jpeg';

  return (
    <Box>
      <Box marginBottom={4}>
        <Box display="flex" justifyContent="center" marginBottom={3}>
          <Box
            component="img"
            src={logoUrl}
            alt="Expedientes del Delito"
            onError={(e) => { e.target.style.display = 'none'; }}
            sx={{
              width: { xs: 180, sm: 220 },
              height: { xs: 180, sm: 220 },
              borderRadius: '50%',
              objectFit: 'cover',
              boxShadow: 4,
              border: `3px solid ${theme.palette.primary.main}`,
            }}
          />
        </Box>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Expedientes del Delito: La narrativa de quienes conocen el terreno
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El análisis definitivo sobre criminalidad, justicia y seguridad en Venezuela. Un espacio donde la investigación profunda y la experiencia de campo se unen para diseccionar los casos que marcan la pauta nacional, ofreciendo a las marcas un entorno de máxima credibilidad, seriedad y prestigio periodístico.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Expedientes del Delito?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/expedientesdeldelito"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/expedientesdeldelito
          </Link>
        </Typography>
        <Box display="flex" flexDirection="column" alignItems="center" marginTop={3} marginBottom={2}>
          <Link
            href="https://tnonetwork.com"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <Box
              component="img"
              src={themeMode === 'dark' ? '/images/logos/logo_white.PNG' : '/images/logos/logo_tnonetwork_black.png'}
              alt="TNO Network"
              sx={{
                width: '100%',
                maxWidth: { xs: 220, sm: 280 },
                height: 'auto',
                objectFit: 'contain',
                cursor: 'pointer',
              }}
            />
          </Link>
        </Box>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Es un ecosistema de contenido diseñado para una audiencia que busca la verdad detrás de los hechos. Más allá de la noticia, nos enfocamos en el análisis técnico de expedientes, sistemas carcelarios y prevención ciudadana. En <strong>Expedientes del Delito</strong>, convertimos el suceso en una cátedra de ética periodística y herramientas de seguridad. <strong>1 transmisión en vivo</strong> los domingos a las 6:00 PM por TNO Network, <strong>3 reposiciones</strong> y luego disponible en la <strong>plataforma on-demand</strong>. Además, se publican <strong>clips de los episodios</strong> en todas las redes sociales de TNO Network, Angélica Lugo y Santiago Gutiérrez.
        </Typography>
      </Box>

      {/* Anclas: Santiago Gutiérrez y Angélica Lugo */}
      <Box marginTop={6} marginBottom={4}>
        <Typography
          variant={'h5'}
          fontWeight={700}
          gutterBottom
          color={theme.palette.primary.main}
          align="center"
        >
          NUESTROS ANCLAS: SANTIAGO GUTIÉRREZ Y ANGÉLICA LUGO
        </Typography>
        <Typography
          variant={'body2'}
          color={'textSecondary'}
          sx={{ fontStyle: 'italic', mb: 3, textAlign: 'center' }}
        >
          La dualidad perfecta entre trayectoria y agudeza investigativa
        </Typography>
        <Grid container spacing={4} alignItems="flex-start" justifyContent="center">
          <Grid item xs={12} md={5}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box
                component="img"
                src={santiagoPhotoUrl}
                alt="Santiago Gutiérrez - Expedientes del Delito"
                onError={(e) => { e.target.style.display = 'none'; }}
                sx={{
                  width: { xs: 180, sm: 220 },
                  height: { xs: 180, sm: 220 },
                  borderRadius: '50%',
                  objectFit: 'cover',
                  objectPosition: 'top',
                  boxShadow: 3,
                  border: `3px solid ${theme.palette.primary.main}`,
                }}
              />
              <Typography variant="h6" fontWeight={700} sx={{ mt: 2 }} color="primary">
                Santiago Gutiérrez
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Más de 30 años de experiencia reporteril. La voz de la autoridad y la veteranía en la fuente de sucesos.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box
                component="img"
                src={angelicaPhotoUrl}
                alt="Angélica Lugo - Expedientes del Delito"
                onError={(e) => { e.target.style.display = 'none'; }}
                sx={{
                  width: { xs: 180, sm: 220 },
                  height: { xs: 180, sm: 220 },
                  borderRadius: '50%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                  boxShadow: 3,
                  border: `3px solid ${theme.palette.primary.main}`,
                }}
              />
              <Typography variant="h6" fontWeight={700} sx={{ mt: 2 }} color="primary">
                Angélica Lugo
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Referente en investigación de DDHH y cárceles. La visión crítica y moderna del periodismo de campo.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Typography
          variant={'body1'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 3 }}
        >
          Juntos, crean una plataforma de confianza inigualable para marcas que buscan asociarse con la verdad y la responsabilidad social.
        </Typography>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
